import { inject, Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { FORMS_CONFIG } from '../forms-config.token';

@Injectable({ providedIn: 'root' })
export class AppInsightsService {
  private client: ApplicationInsights | null = null;

  constructor() {
    const config = inject(FORMS_CONFIG);
    if (!config.appInsightsConnectionString) return;

    this.client = new ApplicationInsights({
      config: {
        connectionString: config.appInsightsConnectionString,
        enableAutoRouteTracking: true,
        enableCorsCorrelation: true,
        enableRequestHeaderTracking: true,
        enableResponseHeaderTracking: true,
        correlationHeaderExcludedDomains: ['*.auth0.com'],
      },
    });
    this.client.loadAppInsights();
  }

  trackEvent(name: string, properties?: Record<string, unknown>) {
    this.client?.trackEvent({ name }, properties);
  }

  trackException(error: Error, properties?: Record<string, unknown>) {
    this.client?.trackException({ exception: error }, properties);
  }

  setUserId(userId: string, accountId?: string) {
    this.client?.setAuthenticatedUserContext(userId, accountId);
  }

  clearUserId() {
    this.client?.clearAuthenticatedUserContext();
  }
}
